import React, { HTMLAttributes } from 'react';
import styled from 'styled-components';

import { Styling } from '../../constants';
import { filterI18nProps } from '../../utils/styledComponentsUtils';

const StyledCard = styled.div`
  display: flex;
  flex-direction: column;
  background-color: white;
  padding: ${Styling.DEFAULT_SPACING}px;
  margin-bottom: ${Styling.DEFAULT_SPACING}px;
  border-radius: ${Styling.DEFAULT_BORDER_RADIUS}px;
  box-shadow: 0px 1px 3px 0px rgba(0,0,0,0.2),
    0px 1px 1px 0px rgba(0,0,0,0.14),
    0px 3px 8px -1px rgba(0,0,0,0.12);
`;

interface IProps extends HTMLAttributes<HTMLDivElement> {
}

const Card: React.FC<IProps> = (props: IProps) => (
  <StyledCard {...filterI18nProps(props)} />
);

export default Card;
